import { render } from "./ItemComponent.vue?vue&type=template&id=42daa4ff&scoped=true"
import script from "./ItemComponent.vue?vue&type=script&lang=js"
export * from "./ItemComponent.vue?vue&type=script&lang=js"

import "./ItemComponent.vue?vue&type=style&index=0&id=42daa4ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42daa4ff"]])

export default __exports__